import { useProduction } from './useProduction'

export function environmentFactory(configuration: any, globalEnvironment: any) {
    return {
        // compile object, allow globally set variables to overwrite the default values
        ...configuration,
        ...globalEnvironment,
        gateway: {
            ...(configuration.gateway || {}),
            ...(globalEnvironment.gateway || {}),
        },
        // forced values by built
        production: useProduction,
    }
}
